module.exports = __webpack_public_path__ + "01_medium_gold.0d36fe47.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_medium_gold.png
// module id = aFPV
// module chunks = 0